module.exports = __webpack_public_path__ + "img/ejm.ddaaf3d8.jpg";